var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 130,
    viewBox: "0 0 101 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74081 0.503906H94.2592C95.9171 0.503906 97.5072 1.16252 98.6795 2.33487C99.8519 3.50722 100.51 5.09727 100.51 6.75522V126.424C100.511 126.983 100.362 127.532 100.079 128.014C99.795 128.495 99.3875 128.892 98.8985 129.163C98.4096 129.433 97.8569 129.568 97.2982 129.552C96.7395 129.537 96.1952 129.372 95.722 129.075L50.5 100.712L5.27801 129.068C4.80521 129.365 4.26146 129.53 3.70331 129.546C3.14516 129.562 2.59298 129.428 2.10418 129.158C1.61539 128.888 1.20782 128.492 0.923861 128.011C0.639901 127.531 0.489917 126.982 0.489502 126.424V6.75522C0.489502 5.09727 1.14812 3.50722 2.32047 2.33487C3.49282 1.16252 5.08286 0.503906 6.74081 0.503906ZM88.0079 13.0065H12.9921V109.477L50.5 85.9656L88.0079 109.477V13.0065Z",
    fill: "#7A8699"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarks);
export default __webpack_public_path__ + "static/media/bookmarks.61bbc0cc89dcf94f4ec17b188cca3cb6.svg";
export { ForwardRef as ReactComponent };